export default __webpack_public_path__ + "static/media/WF1.a29a8640.png";